<template>
  <div id="title">
      <h1>{{ title }}</h1>
      <p>{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: String,
    description: {
      type: String,
      default: ''
    }
  }
}
</script>
<style>
 h1 {
   font-size: 1.3rem;
 }
</style>
